<div class="login-page d-flex flex-column flex-root" id="kt_app_root">
  <div class="d-flex flex-column flex-lg-row flex-column-fluid min-vh-100">
    <!-- Form Side -->
    <div
      class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1"
    >
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
        <div class="w-lg-500px p-10">
          <div class="text-center mb-11">
            <h1 class="text-gray-900 fw-bolder mb-3" style="font-size: 2.25rem">
              {{ "forgotPassword.title" | translate }}
            </h1>

            <div class="text-gray-500 fw-semibold" style="font-size: 1.25rem">
              {{ "forgotPassword.subTitle" | translate }}
            </div>
          </div>
          <!-- Forgot Password -->
          <form
            (submit)="submitForgotPassword($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="fv-row mb-8">
              <input
                [(ngModel)]="forgotPasswordForm.email"
                type="text"
                placeholder="Email"
                name="email"
                autocomplete="off"
                class="form-control bg-transparent"
              />
            </div>
            <div class="d-grid mb-10">
              <button type="submit" class="btn btn-primary cursor-pointer">
                <span class="indicator-label">
                  {{ "forgotPassword.sendResetLink" | translate }}
                </span>
              </button>
            </div>
          </form>

          <!-- Back to login -->
          <div class="d-grid mb-10">
            <p class="text-center mt-2">
              <a class="text-primary" routerLink="/login"
                ><i class="feather icon-chevron-left"></i
                >{{ "backToLogin" | translate }}</a
              >
            </p>
          </div>
          <div
            class="w-lg-500px d-flex flex-stack px-10 mx-auto"
            style="justify-content: end"
          ></div>
        </div>
      </div>
    </div>

    <!-- Image Side -->
    <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      style="background-image: url(assets/media/misc/auth-bg.png)"
    >
      <app-welcome-image class="w-100"></app-welcome-image>
    </div>
  </div>
</div>
